import {computed, inject, Injectable} from '@angular/core';
import {UserSelect, UserService} from '../../../../api';
import {injectQuery} from '@tanstack/angular-query-experimental';
import {lastValueFrom} from 'rxjs';
import {QueryKey} from '../../../constants/query-key';

@Injectable({
  providedIn: 'root',
})
export class UserStore {
  private readonly userService = inject(UserService);
  usersQuery = injectQuery(() => ({
    queryKey: [QueryKey.USERS],
    queryFn: () => lastValueFrom(this.userService.getUsers()),
  }));
  users = computed<UserSelect[]>(() => this.usersQuery.data()?.users ?? []);
  isDataLoading = computed(() => this.usersQuery.isLoading());
}
